document.addEventListener("DOMContentLoaded", function () {
  initStoreLocator();

  // View Button Active State
  const buttons = document.querySelectorAll(".view-buttons");
  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      buttons.forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");
    });
  });
});

async function initStoreLocator() {
  const input = document.getElementById("storeSearch");
  const countLabel = document.getElementById("storeCount");
  const storeContainer = document.getElementById("storeCards");
  const template = document.getElementById("storeCardTemplate");

  const suggestionBox = document.createElement("div");
  suggestionBox.id = "suggestionBox";
  suggestionBox.classList.add("suggestion-box");
  input.parentElement.appendChild(suggestionBox);

  const noResultsMessage = document.createElement("div");
  noResultsMessage.textContent = "No stores are available in this location.";
  noResultsMessage.classList.add("no-results-message");
  noResultsMessage.style.textAlign = "left";
  noResultsMessage.style.marginTop = "20px";
  noResultsMessage.style.display = "none";
  storeContainer.appendChild(noResultsMessage);

  if (countLabel) countLabel.style.display = "none";

  const sheetID = "1GEnUrSfASn9vwWdmg2PCJf0ssk2vlA0VW4b8sUgpiQ8";
const apiKey = "AIzaSyDWhXx-QiNSPYoDaSTfN21UoKcF4GEcvqo";
const range = "Store-HUL!A:G";

const SHEET_API_URL = `https://sheets.googleapis.com/v4/spreadsheets/${sheetID}/values/${range}?key=${apiKey}`; const storeSuggestions = new Map();
  const cards = [];

  function normalize(str) {
    return str.toLowerCase().replace(/\s+/g, "");
  }

  try {
    const res = await fetch(SHEET_API_URL);
    if (!res.ok) {
      throw new Error(`Sheets API responded ${res.status} ${res.statusText}`);
    }
    const data = await res.json();
    const rows = data.values;
    const headers = rows[0];
    const records = rows.slice(1);

    records.forEach((row) => {
      const rowData = headers.reduce((obj, key, i) => {
        obj[key.trim()] = row[i] ? row[i].trim() : "";
        return obj;
      }, {});

      const {
        ["Store Name"]: salonName,
        State: state,
        City: city,
        Address: address,
        ["Phone Number"]: phone,
        ["Get Directions"]: directionsLink,
        Pincode: pincode,
      } = rowData;

      const clone = template.content.cloneNode(true);
      clone.querySelector(".store-name").textContent = salonName;
      clone.querySelector(".store-address").textContent = address;
      clone.querySelector(".store-phone-number a").textContent = phone || "N/A";
      clone.querySelector(".store-phone-number a").href = phone
        ? `tel:${phone}`
        : "#";

      const cleanLink = directionsLink?.trim();
      clone.querySelector(".store-directions a").href =
        cleanLink && cleanLink.startsWith("http")
          ? cleanLink
          : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
              address
            )}`;

      const cardEl = clone.querySelector(".store-card");
      cardEl.setAttribute("data-state", state);
      cardEl.setAttribute("data-city", city);
      cardEl.setAttribute("data-pincode", pincode || "");
      setTimeout(() => cardEl.classList.add("loaded"), 50);
      storeContainer.appendChild(clone);
      cards.push(cardEl);

      const cityStateKey = normalize(`${city}${state}`);
      if (!storeSuggestions.has(cityStateKey)) {
        storeSuggestions.set(cityStateKey, {
          suggestion: `${city}, ${state}, India`,
          city,
          state,
        });
      }
      if (pincode && !storeSuggestions.has(pincode)) {
        storeSuggestions.set(pincode, {
          suggestion: pincode,
          pincode,
        });
      }
    });

    function filterCards(term) {
      const normalizedTerm = normalize(term);
      let found = 0;

      cards.forEach((card) => {
        const city = normalize(card.getAttribute("data-city") || "");
        const state = normalize(card.getAttribute("data-state") || "");
        const pincode = normalize(card.getAttribute("data-pincode") || "");
        const combined = `${city}${state}${pincode}`;

        const isMatch = combined.includes(normalizedTerm);
        card.style.display = isMatch ? "flex" : "none";
        if (isMatch) found++;
      });

      noResultsMessage.style.display = found > 0 ? "none" : "block";
      if (countLabel) {
        countLabel.style.display = "block";
        countLabel.textContent = `${found} Store${
          found !== 1 ? "s" : ""
        } found`;
      }
    }

    function showAllCards() {
      cards.forEach((card) => (card.style.display = "flex"));
      if (countLabel) countLabel.style.display = "none";
      noResultsMessage.style.display = "none";
    }

    let selectedIndex = -1;
    let suggestionItems = [];

    function showSuggestions(searchTerm) {
      suggestionBox.innerHTML = "";
      selectedIndex = -1;

      if (!searchTerm) return;

      const normalizedSearch = normalize(searchTerm);
      const matches = Array.from(storeSuggestions.values()).filter((item) =>
        normalize(item.suggestion).includes(normalizedSearch)
      );

      matches.forEach((item) => {
        const div = document.createElement("div");
        div.setAttribute("role", "option");
        div.setAttribute("aria-selected", "false");
        div.textContent = item.suggestion;
        div.classList.add("suggestion-place");

        div.addEventListener("click", () => {
          input.value = item.suggestion;
          suggestionBox.innerHTML = "";

          if (item.city && item.state) {
            filterCards(`${item.city} ${item.state}`);
          } else if (item.pincode) {
            filterCards(item.pincode);
          }
        });

        suggestionBox.appendChild(div);
      });
    }

    let debounce;
    input.addEventListener("input", () => {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        const term = input.value.trim();
        if (!term) {
          showAllCards();
          suggestionBox.innerHTML = "";
          return;
        }
        showSuggestions(term);
        filterCards(term);
      }, 150); // 150-200 ms feels snappy without overloading the DOM
    });

    input.addEventListener("keydown", (e) => {
      const suggestions = suggestionBox.querySelectorAll(".suggestion-place");
      suggestionItems = Array.from(suggestions);

      if (e.key === "ArrowDown") {
        e.preventDefault();
        if (selectedIndex < suggestionItems.length - 1) {
          selectedIndex++;
          updateHighlight();
        }
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        if (selectedIndex > 0) {
          selectedIndex--;
          updateHighlight();
        }
      } else if (e.key === "Enter") {
        e.preventDefault();
        if (selectedIndex >= 0 && suggestionItems[selectedIndex]) {
          suggestionItems[selectedIndex].click();
        }
      }
    });

    function updateHighlight() {
      suggestionItems.forEach((item, index) => {
        const isActive = index === selectedIndex;
        item.classList.toggle("highlighted", isActive);
        item.setAttribute("aria-selected", String(isActive));
      });
    }

    const outsideClick = (e) => {
      if (!input.contains(e.target) && !suggestionBox.contains(e.target)) {
        suggestionBox.innerHTML = "";
      }
    };
    document.addEventListener("click", outsideClick);

    // later, if the section is unloaded:
    // document.removeEventListener("click", outsideClick);
  } catch (err) {
    console.error("Error fetching store data:", err);
  }
}